module.exports = __webpack_public_path__ + "img/male5.a5f9634b.jpeg";